// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import dayjs from "dayjs";
import { get } from "lodash";

import { Container } from "react-components";

import Seo from "../../components/seo";
import Layout from "../../components/layout";
import RichText from "../../components/contentful/richText";
import BlogList from "../../components/blogList";
import BlogMenu from "../../components/blogMenu";
import SocialShare from "../../components/socialShare";

import styles from "./article.css";

function readingTimeFromWords(words) {
    let result = 1;

    if (words) {
        const textLength = words.split(" ").length; // Split by words
        if (textLength > 0) {
            result = Math.ceil(textLength / 200);
        }

        return `${result} min${result > 1 ? "s" : ""} read`;
    }

    return `0 min read`;
}

export default function Category({ data }) {
    const timeRead = readingTimeFromWords(data.contentfulArticle.body.raw);
    const formattedDate = dayjs(data.contentfulArticle.publishDate).format("ddd DD MMMM YYYY");

    return (
        <Layout background={"white"} footerBackground={"white"} navigation={"blog"}>
            <Seo
                image={get(data, "contentfulArticle.preview.gatsbyImageData.images.fallback.src")}
                title={data.contentfulArticle.metaTitle || data.contentfulArticle.title}
                description={data.contentfulArticle.metaDescription}
            />
            <Container size={"full"} className={styles.container}>
                <BlogMenu />
                <article className={styles.article}>
                    <h1 className={styles.title}>{data.contentfulArticle.title}</h1>
                    {data.contentfulArticle.excerpt && (
                        <div className={styles.excerpt}>
                            {data.contentfulArticle.excerpt && <RichText content={data.contentfulArticle.excerpt} />}
                        </div>
                    )}
                    <div className={styles.info}>
                        {timeRead} | {formattedDate}
                        <SocialShare url={`https://whereby.com/blog/${data.contentfulArticle.slug}/`} />
                    </div>
                    <div className={styles.body}>
                        {data.contentfulArticle.body && (
                            <RichText styles={styles} content={data.contentfulArticle.body} />
                        )}
                    </div>
                    {data.contentfulArticle.authors && data.contentfulArticle.authors.length > 0 && (
                        <div className={styles.footer}>
                            Written by
                            {data.contentfulArticle.authors.map((item, index) => (
                                <>
                                    <a key={item.id} href={`/blog/author-${item.slug}/`}>
                                        {item.name}
                                    </a>
                                    {index < data.contentfulArticle.authors.length - 1 && <>, </>}
                                </>
                            ))}
                            <SocialShare url={`https://whereby.com/blog/${data.contentfulArticle.slug}/`} />
                        </div>
                    )}
                </article>
                {data.allContentfulArticle && (
                    <section className={styles.relatedArticles}>
                        <BlogList
                            title={
                                data.contentfulArticle.relatedArticlesTitle
                                    ? data.contentfulArticle.relatedArticlesTitle
                                    : "Other articles you might like"
                            }
                            items={
                                data.contentfulArticle.relatedArticles &&
                                data.contentfulArticle.relatedArticles.length > 0
                                    ? data.contentfulArticle.relatedArticles
                                    : data.allContentfulArticle.nodes
                            }
                        />
                    </section>
                )}
            </Container>
        </Layout>
    );
}

Category.propTypes = {
    data: PropTypes.object,
};

export const query = graphql`
    query ($id: String!) {
        contentfulArticle(id: { eq: $id }) {
            id
            slug
            publishDate
            type
            preview {
                gatsbyImageData(layout: FULL_WIDTH)
            }
            title
            body {
                raw
                references {
                    ... on ContentfulAsset {
                        __typename
                        contentful_id
                        file {
                            url
                            fileName
                            contentType
                        }
                        gatsbyImageData(layout: FULL_WIDTH)
                    }
                    ... on ContentfulArticleEmbedYouTube {
                        __typename
                        contentful_id
                        url
                    }
                    ... on ContentfulArticleCodeBlock {
                        __typename
                        contentful_id
                        code {
                            code
                        }
                    }
                    ... on ContentfulArticleEmbedSpotify {
                        __typename
                        contentful_id
                        url
                        caption
                    }
                    ... on ContentfulArticleEmbedColumns {
                        __typename
                        contentful_id
                        column1 {
                            raw
                            references {
                                ... on ContentfulAsset {
                                    __typename
                                    contentful_id
                                    gatsbyImageData(layout: FULL_WIDTH)
                                }
                            }
                        }
                        column2 {
                            raw
                            references {
                                ... on ContentfulAsset {
                                    __typename
                                    contentful_id
                                    gatsbyImageData(layout: FULL_WIDTH)
                                }
                            }
                        }
                        column3 {
                            raw
                            references {
                                ... on ContentfulAsset {
                                    __typename
                                    contentful_id
                                    gatsbyImageData(layout: FULL_WIDTH)
                                }
                            }
                        }
                    }
                }
            }
            excerpt {
                raw
            }
            authors {
                name
                slug
            }
            categories {
                slug
                title
            }
            metaTitle
            metaDescription
            relatedArticlesTitle
            relatedArticles {
                id
                slug
                publishDate
                type
                body {
                    raw
                }
                preview {
                    gatsbyImageData(layout: FULL_WIDTH, width: 600)
                }
                title
                excerpt {
                    raw
                }
            }
        }

        allContentfulArticle(limit: 6, sort: { fields: publishDate, order: DESC }) {
            nodes {
                id
                slug
                publishDate
                type
                body {
                    raw
                }
                preview {
                    gatsbyImageData(layout: FULL_WIDTH, width: 600)
                }
                title
                excerpt {
                    raw
                }
            }
        }
    }
`;
